import { createFileRoute } from '@tanstack/react-router'
import { UserEditorPage } from '@/features/users/editor'

export const Route = createFileRoute('/users_/$userId/edit')({
  component: RouteComponent,
})

function RouteComponent() {
  const { userId } = Route.useParams()
  return <UserEditorPage userId={userId} />
}
